import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { FoodTypesDropDownData } from './food-types-drop-down-model';

export class FoodTypesDropDownDataResponseModel extends GlobalResponseObject{
    data?: FoodTypesDropDownData[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //FoodTypesDropDownData[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: FoodTypesDropDownData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
